import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {AbstractModalComponent} from "../abstract-modal/abstract-modal.component";
import {WarningModalService} from "../../services/warning-modal/warning-modal.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-email-sms-preview-modal',
  templateUrl: './email-sms-preview-modal.component.pug',
  styleUrls: ['./email-sms-preview-modal.component.scss'],
  standalone: false
})
export class EmailSmsPreviewModalComponent extends AbstractModalComponent implements OnInit {

  @ViewChild('orgForm', {static: false}) orgForm: any;
  @Input() templates : any;
  @Input() managerTemplate = false;
  @Input() orgLogo : any;
  @Input() color : any;
  @Input() secondary_color : any;
  public saveTemplate: EventEmitter<any> = new EventEmitter<any>()
  logoSrc = '';
  subjectLine = '';
  emptyTemplate = true;
  templateType = 'exit';
  public backClick: EventEmitter<any> = new EventEmitter<any>()
  public saveClick: EventEmitter<any> = new EventEmitter<any>()
  constructor(public _bsModalRef: BsModalRef, 
    public modal: WarningModalService, 
    private permission: PermissionsService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    if(this.orgLogo) {
      this.logoSrc = this.orgLogo;
    }
    else {
      this.logoSrc = 'https://assets.xref.com/omni/email/xref_icon_green.png';
    }
    this.templates.forEach((val, index) => {
      if (val['sms'] || val['email_body'] || val['email_subject']) this.emptyTemplate = false;
      if(index !== 0 && this.subjectLine) {
        this.subjectLine = this.subjectLine.concat(' | ').concat(val.email_subject);
        return;
      }
      this.subjectLine = val.email_subject;
    })
  }

  cancel() {
    this._bsModalRef.hide();
    this.backClick.emit(true);
    
  }

  save() {
    this._bsModalRef.hide();
    this.saveClick.emit(true)
  }

  getForm() {
    return this.orgForm;
  }

}
